/* src/app/forms/translate-form/translate-form-new/translate-form-new.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}
.main-container-edit {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.form-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  gap: 20px;
  padding-top: 20px;
}
.toolbar-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
actions-buttons {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
/*# sourceMappingURL=translate-form-new.component.css.map */
